export const RAGE_RIGHT = {
  RAGE_ADMIN: "RageAdmin",
  RAGE_BERATER_EINS: "RageBerater1",
  RAGE_BERATER_ZWEI: "RageBerater2",
  RAGE_DEUBA_CALLCENTER: "Callcenter",
  VERSENEO_SERVICECENTER: "VerseNeoServiceCenter"
}
